import React from "react";
import { Link } from "react-router-dom";

const PNFHead = () => {
  return (
    <div

      className="breadcrumbs d-flex align-items-center"
    >
      <div
        className="container position-relative d-flex flex-column align-items-center"
        data-aos="fade"
      >
        <ol>
          <li>
            <Link to={"/"}>Home</Link>
          </li>
          <li>Page Not Found</li>
        </ol>
      </div>
    </div>
  );
};

export default PNFHead;
